import { MemoryBuffer } from '../utils/memoryBuffer';
import { MessageFlags, SignatureByte } from 'app/modules/remote-control-ng/definitions';

export enum RCPacketOffsets {
    PACKET_SIZE = 0,
    SIGNATURE = 4,
    COMMAND_POSITION = 5,
    FLAGS = 6
}

class MessageHeader {
    size: number;
    sig: number;
    command: number;
    flags: number;
    requestId: number;
    errorCode: number;
}

export class BaseMessage {
    protected header: MessageHeader = new MessageHeader();
    public get reqId(): number { return this.header.requestId; }
    public get command(): number { return this.header.command; }
    public get errorCode(): number { return this.header.errorCode; }
    public get isRequest(): boolean { return !!(this.header.flags & MessageFlags.HAS_REQID); } 
    public get signature(): number { return this.header.sig; }

    constructor() {
        this.header.sig = SignatureByte.SignatureRemoteControlMessage;
    }

    public serialize(): Uint8Array {
        const buffer = new MemoryBuffer();
        this.serializeHeader(buffer);
        this.serializeBody(buffer);
        this.writeMessageSize(buffer);
        return buffer.getByteArray();
    }

    public deserialize(data: Uint8Array): void {
        const buffer = new MemoryBuffer(data);
        this.deserializeHeader(buffer);
        this.deserializeBody(buffer);
    }

    public serializeBody(buffer: MemoryBuffer): void {
    }

    public deserializeBody(buffer: MemoryBuffer): void {
    }

    protected deserializeHeader = (buffer: MemoryBuffer): void => {
        this.header.size = buffer.readInt32BE();
        this.header.sig = buffer.readUInt8();
        this.header.command = buffer.readUInt8();
        this.header.flags = buffer.readCompInt();
        if ((this.header.flags & MessageFlags.HAS_REQID) !== 0) {
            this.header.requestId = buffer.readCompInt();
        }
        if ((this.header.flags & MessageFlags.HAS_ERRORCODE) !== 0) {
            this.header.errorCode = buffer.readCompInt();
        } else {
            this.header.errorCode = 0;
        }
    }

    private serializeHeader = (buffer: MemoryBuffer): void => {
        buffer.writeInt32BE(this.header.size);
        buffer.writeUInt8(this.header.sig);
        buffer.writeUInt8(this.header.command);
        buffer.writeCompInt(this.header.flags);
        // eslint-disable-next-line no-bitwise
        if ((this.header.flags & MessageFlags.HAS_REQID) !== 0) {
            buffer.writeCompInt(this.header.requestId);
        }
        // eslint-disable-next-line no-bitwise
        if ((this.header.flags & MessageFlags.HAS_ERRORCODE) !== 0) {
            buffer.writeCompInt(this.header.errorCode);
        }
    }

    private writeMessageSize = (buffer: MemoryBuffer): void => {
        const messageLength = buffer.getPosition();
        buffer.seek(0);
        buffer.writeInt32BE(messageLength);
        buffer.seek(messageLength);
    }

    public setRequestId(reqId: number) {
        this.header.requestId = reqId;
        this.header.flags = 0x24;
    }
}